import { apiServiceProxy } from 'v2/services/api-proxy';
import type { ApiServiceProxy } from 'v2/services/api-proxy';

class FIDCService {
  constructor(private apiService: ApiServiceProxy) {}

  public validateCustomerReject = (customerId: number) => {
    return this.apiService.get(`fidc/validate-customer-reject/${customerId}`);
  };
}

export const fidcService = new FIDCService(apiServiceProxy);
